// import React, { useEffect, useMemo, useState } from 'react';
// import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
// import format from 'date-fns/format';
// import parse from 'date-fns/parse';
// import startOfWeek from 'date-fns/startOfWeek';
// import getDay from 'date-fns/getDay';
// import enUS from 'date-fns/locale/en-US';
// import fr from 'date-fns/locale/fr';
// import ar from 'date-fns/locale/ar-SA';
// import 'react-big-calendar/lib/css/react-big-calendar.css';
// import { findAllDoctorAvailabilityByClinicId } from '../../hooks/services/api-services';
// import { useSelector } from 'react-redux';
// import { decryptAEStoJSON } from '../../utils/utilities';
// import { useTranslation } from 'react-i18next';
// import { ROUTES } from '../../hooks/routes/routes-constant';
// import BreadCrum from '../../components/common/BreadCrum';
// import { useNavigate } from 'react-router-dom';

// // Locale mapping
// const localesMap = {
//   en: enUS,
//   fr: fr,
//   ar: ar,
// };

// // Utility to generate pastel color from a name
// const generateColorFromName = (name) => {
//   let hash = 0;
//   for (let i = 0; i < name.length; i++) {
//     hash = name.charCodeAt(i) + ((hash << 5) - hash);
//   }
//   const hue = Math.abs(hash % 360);
//   return `hsl(${hue}, 70%, 80%)`;
// };

// // Convert slot data to calendar events
// const mapSlotDataToEvents = (slotData = []) => {
//   const events = [];

//   slotData.forEach(({ doctorName, dateWiseAvailabilities }) => {
//     (dateWiseAvailabilities || []).forEach(({ date, onlineSlots = [], offlineSlots = [] }) => {
//       const allSlots = [...onlineSlots, ...offlineSlots];

//       allSlots.forEach(slot => {
//         const start = parse(`${date} ${slot.startTime}`, 'yyyy-MM-dd HH:mm', new Date());
//         const end = parse(`${date} ${slot.endTime}`, 'yyyy-MM-dd HH:mm', new Date());

//         events.push({
//           title: `Dr. ${doctorName}`,
//           tooltip: `${doctorName} (${slot.type})`,
//           start,
//           end,
//           doctorName,
//           type: slot.type,
//         });
//       });
//     });
//   });

//   return events;
// };

// const DoctorSlotsCalendar = () => {
//   const { value } = useSelector((state) => state?.loggedUser);
//   const userData = decryptAEStoJSON(value);
//   const clinicId = userData?.id;
//   const navigate = useNavigate();
//   const [slotData, setSlotData] = useState([]);
//   const [selectedDoctor, setSelectedDoctor] = useState('all');
//   const { t, i18n } = useTranslation();

//   // Dynamic localizer using current language
//   const localizer = useMemo(() => dateFnsLocalizer({
//     format,
//     parse,
//     startOfWeek,
//     getDay,
//     locales: localesMap,
//     locale: localesMap[i18n.language] || enUS,
//   }), [i18n.language]);

//   // Calendar message labels in selected language
//   const messages = useMemo(() => ({
//     allDay: t("All day"),
//     previous: t("Back"),
//     next: t("Next"),
//     today: t("Today"),
//     month: t("Month"),
//     week: t("Week"),
//     day: t("Day"),
//     agenda: t("Agenda"),
//     date: t("Date"),
//     time: t("Time"),
//     event: t("Event"),
//     noEventsInRange: t("No events in this range."),
//   }), [t]);

//   // Formats for dynamic date display based on locale
//   const formats = useMemo(() => ({
//     dayFormat: (date, culture, localizer) =>
//       format(date, 'EEEE dd MMMM', { locale: localesMap[i18n.language] || enUS }),

//     dayHeaderFormat: (date, culture, localizer) =>
//       format(date, 'EEEE dd MMMM', { locale: localesMap[i18n.language] || enUS }),

//     agendaDateFormat: (date, culture, localizer) =>
//       format(date, 'EEEE, dd MMMM yyyy', { locale: localesMap[i18n.language] || enUS }),

//     // You can optionally add more formats here if needed
//   }), [i18n.language]);

//   // Fetch slot data
//   useEffect(() => {
//       const lang = i18n.language; // assign languageType separately

//     findAllDoctorAvailabilityByClinicId(clinicId,lang)
//       .then(res => {
//         const result = res?.data?.data?.doctorAvailabilityList;
//         setSlotData(Array.isArray(result) ? result : []);
//       })
//       .catch(err => {

//         setSlotData([]);
//       });
//   }, [clinicId,i18n.language]);

//   const doctorList = useMemo(() => {
//     const names = Array.from(new Set(slotData?.map(d => d.doctorName)));
//     return ['all', ...names];
//   }, [slotData]);

//   const doctorColorMap = useMemo(() => {
//     const map = {};
//     slotData.forEach(d => {
//       if (!map[d.doctorName]) {
//         map[d.doctorName] = generateColorFromName(d.doctorName);
//       }
//     });
//     return map;
//   }, [slotData]);

//   const allEvents = useMemo(() => mapSlotDataToEvents(slotData), [slotData]);
//   const filteredEvents = useMemo(() => {
//     return selectedDoctor === 'all'
//       ? allEvents
//       : allEvents.filter(e => e.doctorName === selectedDoctor);
//   }, [selectedDoctor, allEvents]);

//   const eventStyleGetter = (event) => {
//     const backgroundColor = doctorColorMap[event.doctorName] || '#ccc';
//     return {
//       style: {
//         backgroundColor,
//         borderRadius: '6px',
//         color: '#000',
//         border: 'none',
//       },
//     };
//   };

//   return (
//     <div className="main_datatable my-lg-3 my-1">
//       <BreadCrum
//         firstData={t("Availability Management")}
//         iconshow1={true}
//         secondData={t("Show Availability")}
//         onFirstDataClick={() => navigate(ROUTES.AVAILABILITY)}
//       />
//       <label style={{ fontWeight: 'bold' }}>{t("Filter by Doctor:")} </label>
//       <select value={selectedDoctor} onChange={e => setSelectedDoctor(e.target.value)}>
//         {doctorList.map(name => (
//           <option key={name} value={name}>
//             {name === 'all' ? t('All Doctors') : name}
//           </option>
//         ))}
//       </select>

//       <div style={{ height: '80vh', marginTop: '20px' }}>
//         <Calendar
//           localizer={localizer}
//           events={filteredEvents}
//           messages={messages}
//           formats={formats}
//           tooltipAccessor="tooltip"
//           eventPropGetter={eventStyleGetter}
//           startAccessor="start"
//           endAccessor="end"
//           titleAccessor="title"
//           views={['day', 'week', 'month', 'agenda']}
//           defaultView="day"
//           step={15}
//           timeslots={1}
//           style={{ height: '100%' }}
//         />
//       </div>
//     </div>
//   );
// };

// export default DoctorSlotsCalendar;


import React, { useEffect, useMemo, useState } from 'react';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import format from 'date-fns/format';
import parse from 'date-fns/parse';
import startOfWeek from 'date-fns/startOfWeek';
import getDay from 'date-fns/getDay';
import enUS from 'date-fns/locale/en-US';
import fr from 'date-fns/locale/fr';
import ar from 'date-fns/locale/ar-SA';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import { findAllDoctorAvailabilityByClinicId } from '../../hooks/services/api-services';
import { useSelector } from 'react-redux';
import { decryptAEStoJSON } from '../../utils/utilities';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '../../hooks/routes/routes-constant';
import BreadCrum from '../../components/common/BreadCrum';
import { useNavigate } from 'react-router-dom';
import dayjs from 'dayjs';

// Locale mapping
const localesMap = {
  en: enUS,
  fr: fr,
  ar: ar,
};

// Utility to generate pastel color from a name
const generateColorFromName = (name) => {
  let hash = 0;
  for (let i = 0; i < name.length; i++) {
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash % 360);
  return `hsl(${hue}, 70%, 80%)`;
};

// Convert slot data to calendar events
// const mapSlotDataToEvents = (slotData = []) => {
//   const events = [];

//   slotData.forEach(({ doctorName, dateWiseAvailabilities }) => {
//     (dateWiseAvailabilities || []).forEach(({ date, onlineSlots = [], offlineSlots = [] }) => {
//       const allSlots = [...onlineSlots, ...offlineSlots];

//       allSlots.forEach(slot => {
//         const start = parse(`${date} ${slot.startTime}`, 'yyyy-MM-dd HH:mm', new Date());
//         const end = parse(`${date} ${slot.endTime}`, 'yyyy-MM-dd HH:mm', new Date());

//         events.push({
//           title: `Dr. ${doctorName}`,
//           tooltip: `${doctorName} (${slot.type})`,
//           start,
//           end,
//           doctorName,
//           type: slot.type,
//         });
//       });
//     });
//   });

//   return events;
// };

const mapSlotDataToEvents = (slotData = []) => {
  const events = [];

  slotData.forEach(({ doctorName, dateWiseAvailabilities }) => {
    (dateWiseAvailabilities || []).forEach(
      ({ date, onlineSlots = [], offlineSlots = [] }) => {
        const allSlots = [...onlineSlots, ...offlineSlots];

        allSlots.forEach(slot => {
          const start = dayjs
            .utc(`${date} ${slot.startTime}`, "YYYY-MM-DD HH:mm")
            .local()
            .toDate();

          const end = dayjs
            .utc(`${date} ${slot.endTime}`, "YYYY-MM-DD HH:mm")
            .local()
            .toDate();

          events.push({
            title: `Dr. ${doctorName}`,
            tooltip: `${doctorName} (${slot.type})`,
            start,
            end,
            doctorName,
            type: slot.type,
          });
        });
      }
    );
  });

  return events;
};

const DoctorSlotsCalendar = () => {
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);
  const clinicId = userData?.id;
  const navigate = useNavigate();
  const [slotData, setSlotData] = useState([]);
  const [selectedDoctor, setSelectedDoctor] = useState('all');
  const { t, i18n } = useTranslation();

  // Dynamic localizer using current language
  const localizer = useMemo(() => dateFnsLocalizer({
    format,
    parse,
    startOfWeek,
    getDay,
    locales: localesMap,
    locale: localesMap[i18n.language] || enUS,
  }), [i18n.language]);

  // Calendar message labels in selected language
  const messages = useMemo(() => ({
    allDay: t("All day"),
    previous: t("Back"),
    next: t("Next"),
    today: t("Today"),
    month: t("Month"),
    week: t("Week"),
    day: t("Day"),
    agenda: t("Agenda"),
    date: t("Date"),
    time: t("Time"),
    event: t("Event"),
    noEventsInRange: t("No events in this range."),
  }), [t]);

  // Formats for dynamic date display based on locale
  const formats = useMemo(() => ({
    dayFormat: (date, culture, localizer) =>
      format(date, 'EEEE dd MMMM', { locale: localesMap[i18n.language] || enUS }),

    dayHeaderFormat: (date, culture, localizer) =>
      format(date, 'EEEE dd MMMM', { locale: localesMap[i18n.language] || enUS }),

    agendaDateFormat: (date, culture, localizer) =>
      format(date, 'EEEE, dd MMMM yyyy', { locale: localesMap[i18n.language] || enUS }),

    // You can optionally add more formats here if needed
  }), [i18n.language]);

  // Fetch slot data
  useEffect(() => {
      const lang = i18n.language; // assign languageType separately

    findAllDoctorAvailabilityByClinicId(clinicId,lang)
      .then(res => {
        const result = res?.data?.data?.doctorAvailabilityList;
        setSlotData(Array.isArray(result) ? result : []);
      })
      .catch(err => {

        setSlotData([]);
      });
  }, [clinicId,i18n.language]);

  const doctorList = useMemo(() => {
    const names = Array.from(new Set(slotData?.map(d => d.doctorName)));
    return ['all', ...names];
  }, [slotData]);

  const doctorColorMap = useMemo(() => {
    const map = {};
    slotData.forEach(d => {
      if (!map[d.doctorName]) {
        map[d.doctorName] = generateColorFromName(d.doctorName);
      }
    });
    return map;
  }, [slotData]);

  const allEvents = useMemo(() => mapSlotDataToEvents(slotData), [slotData]);
  const filteredEvents = useMemo(() => {
    return selectedDoctor === 'all'
      ? allEvents
      : allEvents.filter(e => e.doctorName === selectedDoctor);
  }, [selectedDoctor, allEvents]);

  const eventStyleGetter = (event) => {
    const backgroundColor = doctorColorMap[event.doctorName] || '#ccc';
    return {
      style: {
        backgroundColor,
        borderRadius: '6px',
        color: '#000',
        border: 'none',
      },
    };
  };

  return (
    <div className="main_datatable my-lg-3 my-1">
      <BreadCrum
        firstData={t("Availability Management")}
        iconshow1={true}
        secondData={t("Show Availability")}
        onFirstDataClick={() => navigate(ROUTES.AVAILABILITY)}
      />
      <label style={{ fontWeight: 'bold' }}>{t("Filter by Doctor:")} </label>
      <select value={selectedDoctor} onChange={e => setSelectedDoctor(e.target.value)}>
        {doctorList.map(name => (
          <option key={name} value={name}>
            {name === 'all' ? t('All Doctors') : name}
          </option>
        ))}
      </select>

      <div style={{ height: '80vh', marginTop: '20px' }}>
        <Calendar
          localizer={localizer}
          events={filteredEvents}
          messages={messages}
          formats={formats}
          tooltipAccessor="tooltip"
          eventPropGetter={eventStyleGetter}
          startAccessor="start"
          endAccessor="end"
          titleAccessor="title"
          views={['day', 'week', 'month', 'agenda']}
          defaultView="day"
          step={15}
          timeslots={1}
          style={{ height: '100%' }}
        />
      </div>
    </div>
  );
};

export default DoctorSlotsCalendar;
